module.exports = __webpack_public_path__ + "models/scene4.11924b7.atlas";